import { hydrateSsrOnly } from '~/services/lazy-hydration'

export const RichTextRenderer = hydrateSsrOnly(() =>
  import('./rich-text-renderer')
)

export const CdpContainer = hydrateSsrOnly(() => import('./cdp-container'))
